import React from 'react';
import { Icon } from '../components/index';
import { NavLink } from 'react-router-dom';

const Navigation = () => {
  return (
    <ul className="navigation">
      <li><NavLink exact className="item" activeClassName="active" to="/"><div className="icon-wrapper"><Icon.Home /></div><span className="label">Home</span></NavLink></li>
      <li><NavLink className="item" activeClassName="active" to="/profile"><div className="icon-wrapper"><Icon.User /></div><span className="label">Profile</span></NavLink></li>
      <li><NavLink className="item" activeClassName="active" to="/contact"><div className="icon-wrapper"><Icon.Contact /></div><span className="label">Contacts</span></NavLink></li>
      <li><NavLink className="item" activeClassName="active" to="/guideline">{/*<div className="icon-wrapper"><Icon.Printer /></div>*/}<span className="label">How To's</span></NavLink></li>
    </ul>
  )
}

export default Navigation